import { FingeringPart } from '../types/fingering';

/** Guitar1-4 の表示ラベル (1st/2nd/3rd/4th) */
export const PART_LABELS: Record<FingeringPart, string> = {
  Guitar1: '1st',
  Guitar2: '2nd',
  Guitar3: '3rd',
  Guitar4: '4th',
};
